import { SearchScenarioId } from 'owa-search-next-common';
import { Suggestion } from 'owa-search-service';

let internalAdditionalQuickActionsFunction: {
    [key: string]: (suggestion: Suggestion) => JSX.Element[];
} = {};

export default function getAdditionalQuickActions(scenarioId: SearchScenarioId) {
    return internalAdditionalQuickActionsFunction[scenarioId];
}

export function registerAdditionalQuickActionsInternal(
    scenarioId: SearchScenarioId,
    additionalQuickActionsFunction: (suggestion: Suggestion) => JSX.Element[]
) {
    internalAdditionalQuickActionsFunction[scenarioId] = additionalQuickActionsFunction;
}
